import React from 'react';

const Dashboard = React.lazy(() => import('./dashboard'));
const TableList = React.lazy(() => import('./TableList'));
const DetailJumlahPegawai = React.lazy(() => import('./DetailJumlahPegawai'));
const KomparasiPegawai = React.lazy(() => import('./KomparasiPegawai'));
const SearchPegawai = React.lazy(() => import('./SearchPegawai'));
const ListPegawai = React.lazy(() => import('./ListPegawai'));
const RiwayatHidup = React.lazy(() => import('../RiwayatHidup'));
const PreviewDRH = React.lazy(() => import('../PreviewDRH'))
const DetailPangkatGolongan = React.lazy(() => import('./DetailPangkatGolongan'));

export const dashboardConfigs = [
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/dashboard/:type',
    element: <TableList />,
  },
  {
    path: '/dashboard/jumlah-pegawai',
    element: <DetailJumlahPegawai />,
  },
  {
    path: '/dashboard/pegawai/riwayat-hidup/:nip',
    element: <RiwayatHidup onGoBack='/dashboard/search-pegawai?&nama=&pendidikan=&programStudi=&mode=pendidikan' />,
  },
  {
    path: '/pegawai/drh-preview',
    element: <PreviewDRH />,
    // permittedRole: ['Operator', 'Administrator']
  },
  {
    path: '/pegawai/drh-preview/:nip',
    element: <PreviewDRH />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1']
  },
  {
    path: '/dashboard/komparasi-pegawai',
    element: <KomparasiPegawai />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1', 'Pegawai']
  },
  {
    path: '/dashboard/search-pegawai',
    element: <SearchPegawai />,
  },
  {
    path: '/dashboard/list-pegawai-v2',
    element: <ListPegawai />,
  },
  {
    path: '/dashboard/list-pegawai-pangkat',
    element: <DetailPangkatGolongan />,
  },
];
